export default "__VITE_ASSET__BRNNMruf__"